module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-DeleteDevice-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('deviceLockDialogTitle')))]), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "deviceLockDialogConfirmText",
      "data-qa": "Dialog-DeleteDevice-ConfirmText",
      "tag": "span"
    }
  }, [_c('el-tag', {
    attrs: {
      "place": "id",
      "type": "info"
    }
  }, [_vm._v(_vm._s(_vm.id))])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, _vm._l((_vm.buttons), function(button, index) {
    return _c('el-button', {
      key: index,
      class: button.class,
      attrs: {
        "data-qa": ("Dialog-DeleteDevice-Button-" + (button.id)),
        "type": button.type || 'warning'
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return button.click($event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(_vm.$t(button.text)) + "\n    ")])
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-228b80ea","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeviceLock/DeviceLock.vue
// module id = 957
// module chunks = 3